var $b8b3e614f55ec090$exports = {};
const $b8b3e614f55ec090$var$displayVideos = document.querySelector("#gallery-container");
let $b8b3e614f55ec090$var$page = 1;
const $b8b3e614f55ec090$var$getGtag = async ()=>{
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({
        domain: window.location.hostname
    });
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };
    const res = await fetch("https://api.itpros.tech/oj/setting/search?page=1&size=1", requestOptions);
    if (!res.ok) throw new Error(`Http error: Status: ${res.status}`);
    const data = await res.json();
    console.log("\uD83D\uDE80 ~ file: dataScript.js:31 ~ getGtag ~ data:", data?.data);
    const resultData = data?.data;
    return resultData;
};
const $b8b3e614f55ec090$var$injectScript = async ()=>{
    const payLoad = await $b8b3e614f55ec090$var$getGtag();
    console.log("\uD83D\uDE80 ~ file: dataScript.js:39 ~ injectScript ~ payLoad:", payLoad);
    var script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${payLoad[0]?.gTag}`;
    document.head.appendChild(script);
    var gTagscript = document.createElement("script");
    gTagscript.text = `window.dataLayer = window.dataLayer || [];\r\n  function gtag(){dataLayer.push(arguments);}\r\n  gtag(\'js\', new Date());\r\n\r\n  gtag(\'config\', \'${payLoad[0]?.gTag}\'});`;
    document.head.appendChild(gTagscript);
};
const $b8b3e614f55ec090$var$getVideos = async (pageIndex)=>{
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const raw = JSON.stringify({});
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
    };
    const res = await fetch(`https://api.itpros.tech/oj/trueobserver_videos/search?page=${pageIndex}&size=20`, requestOptions);
    if (!res.ok) throw new Error(`Http error: Status: ${res.status}`);
    const data = await res.json();
    // console.log("?? ~ file: dataScript.js:26 ~ getLatestNews ~ data:", data)
    return data;
};
const $b8b3e614f55ec090$var$latestVideos = async ()=>{
    const payLoad = await $b8b3e614f55ec090$var$getVideos(1);
    console.log("\uD83D\uDE80 ~ file: videoGallery.js:33 ~ latestVideos ~ payLoad:", payLoad);
    // console.log("?? ~ file: dataScript.js:32 ~ latestNews ~ payLoad:", payLoad.data)
    const videoData = payLoad.data.slice(0, 20);
    console.log("\uD83D\uDE80 ~ file: videoGallery.js:39 ~ latestVideos ~ videoData:", videoData);
    let videoGalleryData = videoData.map((data)=>{
        const { name: name, imageLink: imageLink, videoLink: videoLink } = data;
        return `<div>
                       <a data-fancybox="video-gallery" href="https://www.youtube.com/embed/${videoLink}?autoplay=1&allowfullscreen"><img src=${imageLink}></a>
                      
                    </div>`;
    }).join("");
    $b8b3e614f55ec090$var$displayVideos.innerHTML = videoGalleryData;
};
const $b8b3e614f55ec090$var$includeHTML = ()=>{
    const button = document.querySelector("#triggerEl");
    const menu = document.querySelector("#targetEl");
    button.addEventListener("click", ()=>{
        menu.classList.toggle("hidden");
    });
    let langChange = document.querySelector("#lang");
    if (localStorage.hasCodeRunBefore && !localStorage.telugu) {
        console.log("?? ~ file: include.js:37 ~ includeHTML ~ localStorage.hasCodeRunBefore:", localStorage.hasCodeRunBefore);
        const language = `<li>
              <a href="?portal=$english#googtrans(te|en)" target="_self"
                   class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent"><span translate="no">English</span></a>
         </li>`;
        langChange.innerHTML = language;
        langChange.addEventListener("click", ()=>{
            localStorage.removeItem("hasCodeRunBefore");
            localStorage.setItem("telugu", true);
            googleTranslateElementInit("en");
        });
    } else if (!localStorage.hasCodeRunBefore && localStorage.telugu) {
        const language = `<li>
          <a href="?portal=$telugu#googtrans(en|te)" target="_self"
               class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent">
</a>
     </li>`;
        langChange.innerHTML = language;
        langChange.addEventListener("click", ()=>{
            localStorage.removeItem("telugu");
            localStorage.setItem("hasCodeRunBefore", true);
            googleTranslateElementInit("te");
        });
    } else {
        const language = `<li>
          <a href="?portal=$telugu#googtrans(en|te)" target="_self"
               class="block py-2 px-3 md:p-0 text-white rounded md:bg-transparent">
</a>
     </li>`;
        langChange.innerHTML = language;
        langChange.addEventListener("click", ()=>{
            localStorage.removeItem("telugu");
            localStorage.setItem("hasCodeRunBefore", true);
            googleTranslateElementInit("te");
        });
    }
};
const $b8b3e614f55ec090$var$infinityScroll = async ()=>{
    $(window).scroll(function() {
        if ($(window).scrollTop() == $(document).height() - $(window).height()) {
            $b8b3e614f55ec090$var$page += 1;
            $b8b3e614f55ec090$var$getVideos($b8b3e614f55ec090$var$page).then((res)=>{
                // console.log("?? ~ file: dataScript.js:32 ~ latestNews ~ payLoad:", payLoad.data)
                const videoData = res.data.slice(0, 20);
                console.log("\uD83D\uDE80 ~ file: videoGallery.js:39 ~ latestVideos ~ videoData:", videoData);
                let videoGalleryData = videoData.map((data)=>{
                    const { name: name, imageLink: imageLink, videoLink: videoLink } = data;
                    return `<div>
                       <a data-fancybox="video-gallery" href="https://www.youtube.com/embed/${videoLink}?autoplay=1&allowfullscreen"><img src=${imageLink}></a>
                      
                    </div>`;
                }).join("");
                $("#gallery-container").append(videoGalleryData);
            });
        }
    });
};
$b8b3e614f55ec090$var$includeHTML();
$b8b3e614f55ec090$var$injectScript();
$b8b3e614f55ec090$var$latestVideos();
$b8b3e614f55ec090$var$infinityScroll();
$('[data-fancybox="video-gallery"]').fancybox({
    afterLoad: function(instance, current) {
        // Remove scrollbars and change background
        current.$content.css({
            overflow: "visible",
            background: "#000"
        });
    },
    onUpdate: function(instance, current) {
        var width, height, ratio = 16 / 9, video = current.$content;
        if (video) {
            video.hide();
            width = current.$slide.width();
            height = current.$slide.height() - 100;
            if (height * ratio > width) height = width / ratio;
            else width = height * ratio;
            video.css({
                width: width,
                height: height
            }).show();
        }
    }
});


//# sourceMappingURL=video-gallery.b7797dac.js.map
